import Dialog from './dialog/';

export { Dialog };


// WEBPACK FOOTER //
// ./packages/kendo-dialog-react-wrapper/src/index.ts